var map = {
	"./John-Dickenson.png": 19,
	"./as_bryden.jpg": 153,
	"./axe.png": 9972,
	"./baker.jpg": 7861,
	"./blue_waters.png": 2702,
	"./bp_cypre.png": 8358,
	"./bpi.png": 2164,
	"./bryden_stokes_sils_services.png": 5452,
	"./carib.png": 8483,
	"./carib_brewery.png": 136,
	"./champion_x.png": 1469,
	"./columbus.communication.jpg": 6927,
	"./columbus.communication.png": 4836,
	"./dof.jpeg": 4795,
	"./expro.png": 9854,
	"./exxon.png": 3857,
	"./franks.jpg": 8369,
	"./franks.png": 6122,
	"./ftFarfan.png": 6457,
	"./g-boats.png": 9863,
	"./gafoors.jpg": 5329,
	"./gpc.png": 4498,
	"./halliburton.png": 6143,
	"./login_page_art.svg": 1048,
	"./logo.png": 6949,
	"./mi-cameron.jpg": 5177,
	"./modec.png": 3623,
	"./nov.png": 2779,
	"./oceaneering.jpg": 7737,
	"./oceaneering.png": 6343,
	"./omni.jpg": 8991,
	"./pepesmarketing.png": 1151,
	"./point_lisas_nitrogen.png": 2950,
	"./powersave.png": 7515,
	"./prestige_holding_limited.png": 5965,
	"./pricesmart.png": 1652,
	"./saipem.png": 9834,
	"./sbm.jpg": 966,
	"./schlumberger.png": 2304,
	"./seacor.png": 5293,
	"./styles.scss": 9651,
	"./subsea7.png": 8861,
	"./technipfmc.png": 3835,
	"./toyota_trinidad.png": 8830,
	"./trinity_exploration.png": 3101,
	"./valaris.jpg": 9141,
	"./weatherford.jpg": 7753,
	"./yara.png": 229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;